import { render, staticRenderFns } from "./ConceptsOpeningHours.vue?vue&type=template&id=71dbdb36"
import script from "./ConceptsOpeningHours.vue?vue&type=script&lang=ts"
export * from "./ConceptsOpeningHours.vue?vue&type=script&lang=ts"
import style0 from "./ConceptsOpeningHours.vue?vue&type=style&index=0&id=71dbdb36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports